import {
  FacebookFilled,
  InstagramFilled,
  LinkedinFilled,
  TikTokFilled,
  WhatsAppOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FACEBOOK_LINK, INSTAGRAM_LINK, LINKEDIN_LINK, TIKTOK_LINK, WHATSAPP_NU } from '../../utils/constants';

const Footer = () => {
  return (
    <footer className="footer pt-4">
      <div className="container text-center">
                {/* Divider Line */}
                <hr className="footer-divider mx-auto my-4" />
        {/* Social Media Links */}
        <div className="d-flex justify-content-center mb-3">
          <ul className="footer-social-icons list-unstyled d-flex justify-content-center mb-0">
            <li className="mx-2">
              <Link to={FACEBOOK_LINK} target="_blank" aria-label="Facebook">
                <FacebookFilled style={{ fontSize: '24px', color: '#4267B2' }} /> 
              </Link>
            </li>
            <li className="mx-2">
              <Link to={INSTAGRAM_LINK} target="_blank" aria-label="Instagram">
                <InstagramFilled style={{ fontSize: '24px', color: '#E4405F' }} />
              </Link>
            </li>
            <li className="mx-2">
              <Link to={TIKTOK_LINK} target="_blank" aria-label="TikTok">
                <TikTokFilled style={{ fontSize: '24px', color: '#000000' }} />
              </Link>
            </li>
            <li className="mx-2">
              <Link to={LINKEDIN_LINK} target="_blank" aria-label="LinkedIn">
                <LinkedinFilled style={{ fontSize: '24px', color: '#0077B5' }} />
              </Link>
            </li>
            <li className="mx-2">
              <a href={WHATSAPP_NU} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <WhatsAppOutlined style={{ fontSize: '24px', color: '#25D366' }} /> 
              </a>
            </li>
          </ul>
        </div>


        <div className="row text-center text-md-start justify-content-center">
          <div className="col-md-4 mb-3">
            <div className="footer-info-item">
              <EnvironmentOutlined style={{ fontSize: '20px', color: '#9aa0a6' }} />
              <span className="ms-2">Sodeco,Star Tower, 2nd Floor</span>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="footer-info-item">
              <PhoneOutlined style={{ fontSize: '20px', color: '#9aa0a6' }} />
              <span className="ms-2">+961 71 222 344</span>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="footer-info-item">
              <MailOutlined style={{ fontSize: '20px', color: '#9aa0a6' }} />
              <span className="ms-2">
                <a href="mailto:info@atox-lb.com">info@atox-lb.com</a>
              </span>
            </div>
          </div>
        </div>


        <div className='mb-2'>Copyright © 2024 AToX</div>
      </div>
    </footer>
  );
};

export default Footer;
